<ng-container *ngTemplateOutlet="skeletonSide"></ng-container>

<ng-template #skeletonSide>
  <div class="card min-h-475px w-100 px-0">
    <div class="card-body d-flex flex-column justify-content-between p-8">
      <div class="d-flex flex-column">
        <div class="skeleton h-200px w-100"></div>
        <div class="skeleton h-35px w-75 mt-5 mb-2"></div>
        <div class="skeleton h-25px w-100 mt-2 mb-6"></div>
        <!-- Enroll / add-to-cart — both `rounded-pill` in the real buy box. -->
        <div class="skeleton rounded-pill h-45px w-100 mb-2"></div>
        <div class="skeleton rounded-pill h-45px w-100 mb-2"></div>
        <div class="skeleton h-25px w-50 mt-10"></div>
        <div class="separator border-2 my-4"></div>
        <div class="d-flex flex-row align-items-center gap-2 mb-4">
          <div class="skeleton h-25px w-25px"></div>
          <div class="skeleton h-20px flex-fill"></div>
        </div>
        <div class="d-flex flex-row align-items-center gap-2 mb-4">
          <div class="skeleton h-25px w-25px"></div>
          <div class="skeleton h-20px flex-fill"></div>
        </div>

        <div class="d-flex flex-row align-items-center gap-2">
          <div class="skeleton h-25px w-25px"></div>
          <div class="skeleton h-20px flex-fill"></div>
        </div>
      </div>
    </div>
  </div>
</ng-template>
